module.exports = __webpack_public_path__ + "static/img/Gauge.4df1d1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/Gauge.png
// module id = 8y/H
// module chunks = 1